// import React, { useContext } from "react";
// import css from "../Modulecss/Home.module.css";
// import { Link } from "react-router-dom";
// import Header from "../Components/Header";
// import { LanguageContext } from "../Components/LanguageContext";
// import { useTheme } from "../../ThemeContext";
// import { colors } from "@mui/material";

// export default function RunningCard({ runnig, winnAmount, game_type }) {
//   const user = localStorage.getItem("userId");
//   // console.log(user,"running")

//   // language
//   const translations = {
//     hi: {
//       view: "देखे",
//       prize: "इनाम",
//       entry: "प्रवेश शुल्क",
//     },
//     en: {
//       view: "view",
//       entry: "Entry Fee ",
//       prize: "Winning Prize",
//     },
//   };

//   const { language } = useContext(LanguageContext);

//   // change theme
//   const theme  = localStorage.getItem('theme')

//   const styles = {
//     color: theme === "light" ? "black" : "black",
//   };

//   return (
//     <>
//       <div
//         className={`${css.betCard} mt-1 battle_card_main card_bottom_border`}
//       >
//         <div className="d-flex">
//           <span
//             className={`${css.betCardTitle} pl-3 d-flex align-items-center headings`}
//             style={{ color: "#000" }}
//           >
//             Playing For
//           </span>
//           <span
//             className={`${css.betCardTitle} pl-3 d-flex align-items-center headings`}
//             style={{ marginLeft: "6px", color: "rgb(87 21 90)" }}
//           >
//             {runnig.Created_by.Name.length > 5 ? `${runnig.Created_by.Name.slice(0, 5)}...` : runnig.Created_by.Name}

//           </span>
//           <span
//             className={`${css.betCardTitle} pl-3 d-flex align-items-center headings`}
//             style={{ marginLeft: "-32px", color: "rgb(87 21 90)" }}
//           >
//             &
//           </span>
//           <span
//             className={`${css.betCardTitle} pl-3 d-flex align-items-center headings `}
//             style={{ marginLeft: "-70px",color: "#000" }}
//           >


//              {runnig.Accepetd_By.Name.length > 5 ? `${runnig.Accepetd_By.Name.slice(0, 5)}....` : runnig.Accepetd_By.Name}
//           </span>

//           <div
//             className={`${css.betCardTitle} d-flex align-items-center headings`}
//           >
//             <span className="ml-auto mr-3"></span>
//           </div>
//         </div>
//         <div className="py-1 row battle_card_inner_bottom runing-padding">
//           <div className="pr-3 text-center col-5" style={{marginLeft:"-37px"}}>

//             <div className="">
//               <span className={css.betCardSubTitle} style={{styles}}>
//                 {translations[language].entry}
//               </span>
//               <div className="d-flex align-items-center justify-content-center">
//                 <img
//                   className="mx-1"
//                   src="/images/moneyrupee.png"
//                   alt=""
//                   width="18x"
//                   height="18x"
//                 />
//                 <span className={css.betCardAmount} style={{color:"#4aaa4d", fontSize:'24px', marginLeft:"2px"}}>{runnig.Game_Ammount}</span>
//               </div>
//             </div>
//           </div>
//           <div className="pr-3 text-center col-2 cxy" style={{top:"10px"}}>
//             <div>
//               {user == runnig.Accepetd_By._id ||
//               user == runnig.Created_by._id ? (
//                 <Link
//                   className={`${css.bgSecondary} ${css.playButton} ${
//                     css.cxy
//                   } position-relative m-2 mx-1 ${
//                     runnig.Status == "conflict" ? "bg-danger" : "bg-success"
//                   }`}
//                   style={{
//                     right: "0px",
//                     top: "-6px",
//                     padding: "10px 17px",
//                   }}
//                   to={{
//                     pathname: `/viewgame1/${runnig._id}`,
//                     state: { prevPath: window.location.pathname },
//                   }}
//                 >
//                   {translations[language].view}
//                 </Link>
//               ) : (
//                 <img
//                   className="mx-1 verses mb-2"
//                   src={process.env.PUBLIC_URL + "/images/Homepage/versus.png"}
//                   alt=""
//                   width="25x"
//                   height="25x"
//                 />
//               )}
//             </div>
//           </div>
//           <div className="text-center col-5" style={{marginRight:"-20px"}}>
//             <div className="">
//               <span className={css.betCardSubTitle} style={{color:"black"}}>
//                 {translations[language].prize}
//               </span>
//               <div className="d-flex align-items-center justify-content-center">
//                 <img
//                   className="mx-1"
//                     src="/images/moneyrupee.png"
//                   alt=""
//                   width="18x"
//                   height="18x"
//                 />
//                 <span className={css.betCardAmount} style={{color:"#4aaa4d", fontSize:'24px',}}>
//                   {runnig.Game_Ammount + winnAmount(runnig.Game_Ammount)}
//                 </span>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }


import React, { useContext } from "react";
import css from "../Modulecss/Home.module.css";
import { Link } from "react-router-dom";
import Header from "../Components/Header";
import { LanguageContext } from "../Components/LanguageContext";
import { useTheme } from "../../ThemeContext";
import { colors } from "@mui/material";

export default function RunningCard({ runnig, winnAmount, game_type }) {
  const user = localStorage.getItem("userId");

  // language
  const translations = {
    hi: {
      view: "देखे",
      prize: "PRIZE",
      entry: "PLAYING FOR",
    },
    en: {
      view: "VIEW",
      entry: "PLAYING FOR",
      prize: "PRIZE",
    },
  };

  const { language } = useContext(LanguageContext);

  // change theme
  const theme = localStorage.getItem('theme');

  return (
    <>
      <div
        className={`${css.betCard} mt-2 position-relative`}
        style={{
          background: "linear-gradient(180deg, #004282 0%, #002347 100%)",
          borderRadius: "6px",
          overflow: "hidden",
          boxShadow: "0 2px 4px rgba(0,0,0,0.3)",
          fontFamily: "sans-serif",
          border: "1px solid rgba(255,255,255,0.08)"
        }}
      >
        {/* TOP METRICS ROW (PLAYING FOR & PRIZE) */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "4px 12px",
            background: "rgba(255, 255, 255, 0.06)",
            borderBottom: "1px solid rgba(255,255,255,0.12)"
          }}
        >
          {/* Playing For / Entry view */}
          <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
            <span style={{ color: "#ffffff", fontSize: "11px", fontWeight: "700", letterSpacing: "0.5px" }}>
              {translations[language].entry}
            </span>
            <div style={{ display: "flex", alignItems: "center", gap: "2px" }}>
              <img
                src="/images/rupee.png"
                alt="₹"
                style={{ width: "20px", height: "20px" }}
              />
              <span style={{ color: "#ffffff", fontSize: "14px", fontWeight: "700" }}>
                {runnig?.Game_Ammount}
              </span>
            </div>
          </div>

          {/* Prize view block */}
          <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
            <span style={{ color: "#ffffff", fontSize: "11px", fontWeight: "700", letterSpacing: "0.5px" }}>
              {translations[language].prize}
            </span>
            <div style={{ display: "flex", alignItems: "center", gap: "2px" }}>
              <img
                src="/images/rupee.png"
                alt="₹"
                style={{ width: "20px", height: "20px" }}
              />
              <span style={{ color: "#ffffff", fontSize: "14px", fontWeight: "700" }}>
                {runnig?.Game_Ammount + winnAmount(runnig?.Game_Ammount)}
              </span>
            </div>
          </div>
        </div>

        {/* BOTTOM VERSUS PLAYERS ROW */}
        <div
          style={{
            padding: "8px 16px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            position: "relative"
          }}
        >
          {/* Player 1 Stack (Creator) */}
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", minWidth: "70px" }}>
            <img
              src="/images/game_user.jpg"
              alt=""
              style={{ width: "26px", height: "26px", borderRadius: "50%", marginBottom: "3px", objectFit: "cover" }}
            />
            <span style={{ color: "#ffcc00", fontSize: "12px", fontWeight: "700", textAlign: "center" }}>
              {runnig?.Created_by?.Name?.length > 8 ? `${runnig.Created_by.Name.slice(0, 8)}...` : runnig?.Created_by?.Name}
            </span>
          </div>

          {/* VS Center Graphic / View Button Conditional Area */}
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            {user === runnig?.Accepetd_By?._id || user === runnig?.Created_by?._id ? (
              <Link
                className={` ${css.playButton}`}
                style={{
                  background: runnig?.Status === "conflict" ? "#dc3545" : "#00c853",
                  color: "#ffffff",
                  fontSize: "11px",
                  fontWeight: "700",
                  padding: "4px 12px",
                  borderRadius: "4px",
                  textDecoration: "none",
                  border: "none",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.2)"
                }}
                to={{
                  pathname: `/viewgame1/${runnig?._id}`,
                  state: { prevPath: window.location.pathname },
                }}
              >
                {translations[language].view}
              </Link>
            ) : (
              <div
                style={{
                  width: "26px",
                  height: "26px",
                  borderRadius: "50%",
                  background: "rgba(255,255,255,0.2)",
                  color: "rgba(255,255,255,0.7)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "10px",
                  fontWeight: "700",
                  border: "1px solid rgba(255,255,255,0.15)"
                }}
              >
                VS
              </div>
            )}
          </div>

          {/* Player 2 Stack (Acceptor) */}
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", minWidth: "70px" }}>
            <img
              src="/images/game_user.jpg"
              alt=""
              style={{ width: "26px", height: "26px", borderRadius: "50%", marginBottom: "3px", objectFit: "cover" }}
            />
            <span style={{ color: "#ffcc00", fontSize: "12px", fontWeight: "700", textAlign: "center" }}>
              {runnig?.Accepetd_By?.Name?.length > 8 ? `${runnig.Accepetd_By.Name.slice(0, 8)}...` : runnig?.Accepetd_By?.Name}
            </span>
          </div>
        </div>
      </div>
    </>
  );
}